import './Spinner.css'
import React from 'react'
import { Spinner as BootstrapSpinner } from 'react-bootstrap'

interface IProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [x: string]: any;
    center?: boolean
}

const Spinner = ({ center, variant, ...otherProps }: IProps) => {
    if (center) {
        return (
            <div className='text-center'>
                < BootstrapSpinner
                    animation='border'
                    variant={variant ? variant : 'primary'}
                    {...otherProps}
                />
            </div>
        )
    }
    return (
        <BootstrapSpinner
            animation='border'
            variant={variant ? variant : 'primary'}
            {...otherProps}
        />
    )
}

export default Spinner